import React, { useState } from "react";
import {
  Modal,
  Button,
  Row,
  Divider,
  message,
} from "antd";
import styled from "styled-components";
import config from 'config';
import { getExportCheckoutSession } from "api/helper";

const DownloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .packageDescription {
    font-weight: 400 !important;
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
  }
  .option-section {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
  .option-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }
  .price-tag {
    font-size: 22px;
    font-weight: 600;
    color: #1890ff;
    margin-bottom: 12px;
  }
  .divider-text {
    color: #999;
    font-size: 13px;
  }
`;

const CollectionDownloadModal = ({ isOpen, onClose, collectionId }) => {
  const [loading, setLoading] = useState(false);

  const handleExportPurchase = async () => {
    setLoading(true);
    try {
      const result = await getExportCheckoutSession(collectionId);
      if (result.error) {
        message.error({ content: result.error, duration: 5 });
        setLoading(false);
        return;
      }
      if (result.data?.already_purchased) {
        message.success({ content: "You already purchased this export! Reloading...", duration: 3 });
        onClose("purchased");
        return;
      }
      if (result.data?.checkout_url) {
        window.location.href = result.data.checkout_url;
      }
    } catch (e) {
      message.error({ content: "Failed to start checkout. Please try again.", duration: 5 });
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Export List"
      width={500}
      style={{ textAlign: "center" }}
      bodyStyle={{ padding: 20 }}
      visible={isOpen}
      onCancel={() => {
        onClose("cancel");
      }}
      footer={
        <Row style={{ justifyContent: "center" }}>
          <Button
            key="back"
            type="text"
            onClick={() => {
              onClose("cancel");
            }}
          >
            No Thanks
          </Button>
        </Row>
      }
    >
      <DownloadWrapper>
        <div className="option-section">
          <p className="packageDescription">
            Export this list as a one-time purchase.
          </p>
          <div className="price-tag">$9.99</div>
          <Button
            type="primary"
            size="large"
            loading={loading}
            onClick={handleExportPurchase}
          >
            Export This List — $9.99
          </Button>
        </div>

        <Divider>
          <span className="divider-text">or</span>
        </Divider>

        <div className="option-section">
          <p className="option-label">
            Upgrade for unlimited exports and more features.
          </p>
          <Button
            size="large"
            href={config.csp_pricing_url}
            target="_blank"
          >
            Upgrade to Professional
          </Button>
        </div>
      </DownloadWrapper>
    </Modal>
  );
};
export default CollectionDownloadModal;
